<template>
  <div class="component">
    <el-card class="box-card item"
             :body-style="{ padding: '0px' }"
             v-bind:style="styling">
      <div class="item--info">
        <i :class="this.icon"
           class="item--info--icon bg-primary"
           v-bind:style="stylingIcon"></i>
        <div class="item--info--text">
          <p>{{ msg}}</p>
          <p>{{data}}</p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    props: {
      msg: String,
      data: String,
      bgColor: String,
      textColor: String,
      width: String,
      icon: String,
    },
    computed: {
      styling() {
        return {
          width: this.width,
          color: this.textColor,

        };
      },
      stylingIcon() {
        return {
          'background-color': this.bgColor,
          color: 'white',
        };
      },
    },
  };
</script>

<style lang="stylus">
  .item {
    border-radius 5px
  }

  .item--info {
  }

  .item--info--icon {
    text-align center
    display block
    float left
    font-size 45px
    padding-left 30px
    padding-right 30px
    line-height 120px
  }

  .item--info--text {
    display flex
    flex-direction column
    justify-content flex-start
    margin-left 10px
    padding-left 10px
    padding-right 10px
  }

  .component {
    /*margin-right 20px*/
  }
</style>
